module.exports = __webpack_public_path__ + "static/media/plus.5540baa0.svg";